<template>
  <div class="sso-handoff" data-testid="sso-handoff">
    <AuthLoginAlert :message="alertMessage" />
    <v-progress-circular
      indeterminate
      :size="32"
      :width="2"
      class="sso-handoff__spinner"
      data-testid="sso-handoff__spinner"
    />
    <p class="sso-handoff__title" data-testid="sso-handoff__title">
      Redirecting to {{ resolvedDisplayName }}
    </p>
    <p class="sso-handoff__hostname" data-testid="sso-handoff__hostname">
      {{ resolvedHostname }}
    </p>
    <v-btn
      block
      outlined
      elevation="0"
      class="sso-handoff__cancel"
      data-testid="sso-handoff__cancel"
      @click="onCancel"
    >
      <span>Cancel</span>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AuthLoginAlert from './AuthLoginAlert.vue';

export default {
  name: 'SsoHandoff',
  components: {
    AuthLoginAlert,
  },
  props: {
    displayName: { type: String, default: '' },
    hostname: { type: String, default: '' },
    alertMessage: { type: String, default: '' },
  },
  computed: {
    ...mapState('auth', [
      'loginHostname',
      'discoverTenants',
      'selectedDiscoverClient',
      'loginOptions',
    ]),
    ...mapGetters('auth', ['idps', 'selectedClient']),
    resolvedDisplayName() {
      if (this.displayName) return this.displayName;
      const firstIdp = this.idps && this.idps[0];
      return (firstIdp && firstIdp.displayName) || 'SSO';
    },
    resolvedHostname() {
      if (this.hostname) return this.hostname;
      if (this.loginHostname) return this.loginHostname;
      const client = this.selectedDiscoverClient || this.selectedClient;
      const selected = (this.discoverTenants || []).find(
        (tenant) => tenant && tenant.client === client,
      );
      if (selected && selected.hostname) return selected.hostname;
      if (this.loginOptions && this.loginOptions.hostname) {
        return this.loginOptions.hostname;
      }
      if (this.loginOptions && this.loginOptions.loginHostname) {
        return this.loginOptions.loginHostname;
      }
      return typeof window !== 'undefined' ? window.location.hostname : '';
    },
  },
  methods: {
    onCancel() {
      this.$store.commit('auth/setSsoInProgress', false);
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SsoHandoff.scss';

.sso-handoff__spinner ::v-deep .v-progress-circular__underlay {
  stroke: var(--slate-250);
  opacity: 1;
}

.sso-handoff__spinner ::v-deep .v-progress-circular__overlay {
  stroke: var(--color-primary-base);
}
</style>
